(function(module) {
    'use strict';

    function SocialCtrl(Store, LoopBackAuth, envService, $stateParams, $window, $timeout) {
        this.$onInit = () => {
            $timeout(this.goToSocial, 0);
        };

        this.goToSocial = () => {
            const subAccountId = Store.getCurrentSubAccountId();

            const { accessTokenId } = LoopBackAuth;
            const { integrationTemplateName, integrationTemplateId } = $stateParams;

            envService.check();

            // set URI
            const API_URI = envService.read('API_URI');
            let href;
            if (subAccountId) {
                href = `${API_URI}/integrations/link/${integrationTemplateName}/${integrationTemplateId}?access_token=${accessTokenId}&subAccountId=${subAccountId}`;
            } else {
                href = `${API_URI}/integrations/link/${integrationTemplateName}/${integrationTemplateId}?access_token=${accessTokenId}`;
            }
            $window.location.href = href;
        };
    }

    function SocialCallbackCtrl() {
    }

    module
        .config(function($stateProvider) {

            // Route
            $stateProvider
                .state('social', {
                    url: '/social/:integrationTemplateName/:integrationTemplateId',
                    data: {
                        pageTitle: 'REGISTER.PAGE_TITLE',
                    },
                    views: {
                        'main@': {
                            templateUrl: '/js/components/layouts/content-only.html',
                            controller: 'MainController as $ctrl',
                        },
                        'content@social': {
                            templateUrl: '/js/social/social.html',
                            controller: 'SocialCtrl as $ctrl',
                        },
                    },
                    bodyClass: 'page--social',
                })

                .state('socialCallback', {
                    url: '/social/:provider/callback',
                    data: {
                        pageTitle: 'REGISTER.PAGE_TITLE',
                    },
                    views: {
                        'main@': {
                            templateUrl: '/js/components/layouts/content-only.html',
                            controller: 'MainController as $ctrl',
                        },
                        'content@social': {
                            templateUrl: '/js/social/social.html',
                            controller: 'SocialCallbackCtrl as $ctrl',
                        },
                    },
                    bodyClass: 'page--social',
                });
        })
        .controller('SocialCtrl', SocialCtrl)
        .controller('SocialCallbackCtrl', SocialCallbackCtrl);

})(angular.module('rocket.components'));
